module.exports = __webpack_public_path__ + "media/images/pokerroom/pokerstars/join-bg-0c199e1f7a8335562bbb1f0e2eab4015.jpg";